import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import SettlementManagementLayer from "../../components/Accounts/SettlementManagementLayer";

const SettlementManagementPage = () => {
  return (
    <MasterLayout>
      <SettlementManagementLayer />
    </MasterLayout>
  );
};

export default SettlementManagementPage;
